import { Injectable } from '@angular/core';
import { PortalClientSectionRights, PortalEntity, SecurityRole, getPortalClientSectionRights } from '@jms/model';
import { Select } from '@jms/shared/ngrx-actions';
import { Observable, map } from 'rxjs';

/** The Client Portal session's selected account, role, and what that role may do on each job and site tab. */
@Injectable({ providedIn: 'root' })
export class ClientPortalContextService {

    @Select('application.selectedEntity')
    public selectedEntity$: Observable<PortalEntity>;

    @Select('application.activeRole')
    public role$: Observable<SecurityRole>;

    public sections$: Observable<PortalClientSectionRights>;

    constructor() {

        this.sections$ = this
            .role$
            .pipe(
                map(role => getPortalClientSectionRights(role)),
            );
    }
}
